// Constantes de dominio para Zuchlag
// Zuchlag es un BUSCADOR/AGREGADOR de auktionen: no procesa pujas,
// sino que agrupa anuncios de auktionshäuser reales y enlaza al original.

// Lista de categorías conocidas (mapeo de los datos que llegan de la API)
// La API puede entregar categorías dinámicas; esta lista sirve de marco
// de filtrado y de respaldo si una categoría viene vacía en un lote.
export const CATEGORIES = [
  { key: 'construction', label: 'Baumaschinen' },
  { key: 'agriculture', label: 'Landwirtschaft' },
  { key: 'vehicles', label: 'Fahrzeuge & Transport' },
  { key: 'industrial', label: 'Industriemaschinen' },
  { key: 'metalworking', label: 'Metallbearbeitung' },
  { key: 'woodworking', label: 'Holzbearbeitung' },
  { key: 'energy', label: 'Energie & Umwelt' },
  { key: 'food', label: 'Lebensmittelindustrie' },
  { key: 'office', label: 'Büro & IT' },
  { key: 'real-estate', label: 'Immobilien' }
]

// Países frecuentes en los datos de Troostwijk (merchados B2B) - etiquetas en alemán (requisito 8)
export const COUNTRIES = [
  { code: 'nl', label: 'Niederlande' },
  { code: 'de', label: 'Deutschland' },
  { code: 'be', label: 'Belgien' },
  { code: 'fr', label: 'Frankreich' },
  { code: 'es', label: 'Spanien' },
  { code: 'it', label: 'Italien' },
  { code: 'pl', label: 'Polen' },
  { code: 'gb', label: 'Vereinigtes Königreich' },
  { code: 'hu', label: 'Ungarn' },
  { code: 'ro', label: 'Rumänien' },
  { code: 'bg', label: 'Bulgarien' },
  { code: 'hr', label: 'Kroatien' },
  { code: 'at', label: 'Österreich' },
  { code: 'ch', label: 'Schweiz' }
]

// Mapeo directo código -> alemán (fallback garantizado; evita mezclar idiomas)
export const COUNTRY_LABELS = Object.fromEntries(COUNTRIES.map((c) => [c.code, c.label]))

// Ordenaciones soportadas por la API (requisito 3: añadir "con más pujas")
export const SORT_OPTIONS = [
  { value: 'newest', label: 'Neu eingestellt' },
  { value: 'closing', label: 'Endet bald' },
  { value: 'price_asc', label: 'Preis aufsteigend' },
  { value: 'price_desc', label: 'Preis absteigend' },
  { value: 'bids', label: 'Meiste Gebote' }
]

// Estados normalizados: texto coherente en alemán (requisito 2 y 8)
export const STATUS_LABELS = {
  active: 'Aktiv',
  upcoming: 'Demnächst',
  ended: 'Beendet',
  cancelled: 'Abgebrochen',
  sold: 'Verkauft',
  reserve_not_met: 'Mindestpreis nicht erreicht'
}

// Opciones de filtro de estado (requisito 3: activo por defecto)
export const STATUS_FILTERS = [
  { value: 'active', label: 'Aktiv' },
  { value: 'upcoming', label: 'Demnächst' },
  { value: 'ended', label: 'Beendet' }
]
